import React from 'react';

interface UcatHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  showToolbar?: boolean;
  headerRight?: React.ReactNode;
  headerRightActions?: React.ReactNode;
  leftActions?: React.ReactNode;
  rightActions?: React.ReactNode;
}

export const UcatHeader: React.FC<UcatHeaderProps> = ({
  title,
  subtitle,
  showToolbar = false,
  headerRight,
  headerRightActions,
  leftActions,
  rightActions,
}) => {
  return (
    <div className="flex flex-col w-full select-none">
      {/* Main Header */}
      <div className="bg-[#006DAA] flex items-center justify-between px-4" style={{ height: (headerRight || headerRightActions) ? "50px" : "47px" }}>
        <div className="flex items-center">
          <h1 className="text-white font-normal m-0 f-tahoma" style={{ fontSize: "21px" }}>
            {title}
          </h1>
          {/* {subtitle && !headerRight && (
            <span className="text-white/90 ml-3 pt-1" style={{ fontSize: "14px" }}>
              {subtitle}
            </span>
          )} */}
        </div>

        {(headerRight || headerRightActions) && (
          <div className="flex items-center gap-4 text-white">
            {headerRightActions}
            {headerRight && (
              <div className="flex flex-col items-end leading-tight pr-1">
                {headerRight}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Optional Toolbar / Secondary Header */}
      {showToolbar && (
        <div className="!bg-[#4678BE] flex items-center justify-between px-1 relative z-10" style={{ height: "30px" }}>
          <div className="flex items-center h-full">
            {leftActions}
          </div>
          <div className="flex items-center h-full">
            {rightActions}
          </div>
        </div>
      )}
    </div>
  );
};
